import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { format } from 'date-fns';
import MyApiClient from '../../../../api-client/MyApiClient';
import { conMotivo } from '../../../components/Util/erroreServer';
import { usePageTitle } from '../../../layouts/PageHeaderExtra';
import { anteprimaFile } from '../../../components/Util/anteprimaFile';

/*
 * Scheda di un documento della struttura (03/10/2026). Prima la riga apriva una finestra con l'anteprima,
 * «Scarica» ed «Elimina»; ora è una pagina. Si torna da dove si è venuti: la pagina Documenti oppure
 * il tab Documenti de «La mia struttura» (navigate state `from`). Il documento si rilegge dall'elenco
 * dei documenti, cercandolo per id.
 */

const getToken = () => {
    const dettagli = sessionStorage.getItem('userDetails');
    return dettagli ? JSON.parse(dettagli).idToken : null;
};

export const SchedaDocumentoStruttura = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const ritorno = location.state?.from || '/struttura/documenti';

    const [documento, setDocumento] = useState(location.state?.documento || null);
    const [caricato, setCaricato] = useState(false);
    const [loadingShowed, setLoadingShowed] = useState(false);
    const [errore, setErrore] = useState('');
    const [confermaElimina, setConfermaElimina] = useState(false);

    useEffect(() => {
        const carica = async () => {
            const token = getToken();
            if (!token) return;
            try {
                const documenti = await new MyApiClient().getDocuments(token);
                const trovato = (documenti || []).find((d) => String(d.id) === String(id));
                if (trovato) {
                    setDocumento({
                        id: trovato.id,
                        'data-caricamento': format(trovato.uploadedAt, 'dd/MM/yyyy HH:mm:ss'),
                        'nome-documento': trovato.name,
                        uri: trovato.uri,
                    });
                } else if (Array.isArray(documenti)) {
                    setDocumento(null);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setCaricato(true);
            }
        };
        carica();
    }, [id]);

    usePageTitle(documento?.['nome-documento']);

    if (!documento) {
        return (
            <Card>
                <Card.Body className="sid-card-body--spaced">
                    {caricato ? 'Documento non trovato.' : 'Caricamento in corso...'}
                </Card.Body>
            </Card>
        );
    }

    const elimina = async () => {
        setConfermaElimina(false);
        const token = getToken();
        if (!token) return;
        setLoadingShowed(true);
        const esito = await new MyApiClient().deleteDoc(token, documento.id);
        setLoadingShowed(false);
        if (!esito) {
            setErrore(conMotivo("Si è verificato un errore durante l'eliminazione"));
            return;
        }
        navigate(ritorno);
    };

    return (
        <>
            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                    <Spinner animation="border" role="status"><span className="sr-only">Loading...</span></Spinner>
                    <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <Modal className="fade" show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>

            <Modal className="fade" show={confermaElimina} onHide={() => setConfermaElimina(false)} centered>
                <Modal.Header closeButton><Modal.Title>Eliminare il documento?</Modal.Title></Modal.Header>
                <Modal.Body>Eliminare il documento «{documento['nome-documento']}»? L'operazione non si può annullare.</Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setConfermaElimina(false)}>Annulla</Button>
                    <Button variant="danger" onClick={elimina}>Elimina</Button>
                </Modal.Footer>
            </Modal>

            <Card>
                <Card.Body className="sid-card-body--spaced">
                    <h5 className="sid-form-section">Documento</h5>
                    <Row className="g-4">
                        <Col md={6}>
                            <Form.Label>Nome documento</Form.Label>
                            <div className="sid-readonly-value">{documento['nome-documento'] || '—'}</div>
                        </Col>
                        <Col md={6}>
                            <Form.Label>Data caricamento</Form.Label>
                            <div className="sid-readonly-value">{documento['data-caricamento'] || '—'}</div>
                        </Col>
                    </Row>

                </Card.Body>
            </Card>

            <div className="d-flex justify-content-between align-items-center gap-4 mt-4">
                <button type="button" className="btn btn-danger light" onClick={() => setConfermaElimina(true)}>Elimina</button>
                <div className="d-flex gap-4">
                    {documento.uri && (
                        <Button className="btn btn-primary" onClick={() => anteprimaFile({ uri: documento.uri, nome: documento['nome-documento'] || documento.name || '' })}>Visualizza</Button>
                    )}
                </div>
            </div>
        </>
    );
};

export default SchedaDocumentoStruttura;
